import { NgxLoggerLevel } from 'ngx-logger';
import { TimezoneType } from 'src/app/enums/timezone-type';
import { AppGuardType } from 'src/app/tinea-components/okta/enum/AppGuardType';
import { DataConsumeType } from 'src/app/tinea-components/okta/enum/DataConsumeType';
import packageInfo from '../../package.json';
import { coreEnvironment } from './core/core.environment';
import { dashboardEnvironment } from './core/dashboard.environment';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  core: coreEnvironment,
  production: false,
  VERSION: packageInfo.version,
  timezone: TimezoneType.LOCAL,
  versionNameInSession: 'version',
  apiUrl: '/front-api',
  urlPublicWwebsite: '',
  // logs
  disableConsoleLogging: false,
  browserLogLevel: NgxLoggerLevel.TRACE,
  serverLogLevel: NgxLoggerLevel.LOG,
  // encryption
  encryptUserSession: false,
  encryptionSecretKey: '!j5;/q3XsBxA5@,78CLPAw_[TP[.@L67ddf?6bh;?#]&U',
  // auth
  authClass: 'AuthentWithCustomOktaService',
  authAppGuard: AppGuardType.AUTHENTICATED_BY_CUSTOM_OKTA_THEN_LOGGEDIN,
  firstNameWhenNotAuthenticated: "Test",
  lastNameWhenNotAuthenticated: "Test",
  authLoginInternal: false, // eg. login by internal form (true) ? or by an other website (false) ?
  authRedirectToPreviousUrl: true,
  authPathRedirectAfterLogin: '/',
  authPathRedirectAfterLogout: '/',
  authPathLoggedInCallback: 'logged-in-callback',
  // key names
  authRedirectToNameInSession: 'redirectTo',
  authTokenNameInSession: 'authToken',
  authUserNameInSession: 'user',
  authExpireAtNameInSession: 'authExpireAt',
  // consumes api
  dataStartApiCall: ['/front-api'],
  dataConsumeType: DataConsumeType.AUTH,  
  dataHeaders: [ {nameInEnv: null, headerName: 'Authorization', mustDecode: false, fieldToDecode: 'uid'} ], // data needed in header for consume data [ {nameInEnv: null, headerName: 'Authorization',mustDecode: false, fieldToDecode: null} ]
  // dataHeaders: [{nameInEnv: 'userId', headerName: 'user-id'} ], // if NOT_AUTHENTICATED_JUST_LOGGEDIN
  userId: '00u3k6faptVSGXpBu0i7',  // key names
  dataTokenTypeNameInSession: 'tokenType',
  dataTokenTypeValueInSession: 'Bearer',
  dataTokenNameInSession: 'dataToken',
  // okta
  okta_client_id: '0oahh909qggH3SpC50i7', // okta app : "Hydrowatt Daisy Integ"
  okta_domain: 'https://tinea.okta-emea.com',
  okta_issuer: `https://tinea.okta-emea.com/oauth2/aushhntkz13z5v9JX0i7`,
  okta_redirectUri: window.location.origin + '/implicit/callback',
  // okta_redirectUri: window.location.origin + '/implicit/callback',
  okta_scope: 'shiva openid',
  brand_name: 'SHIVA DEV',
  // okta custom
  oktaCustom: {
    okta_client_id: '0oahh909qggH3SpC50i7', // okta app : "Hydrowatt Daisy Integ"
    okta_domain: 'https://tinea.okta-emea.com',
    okta_issuer: 'https://tinea.okta-emea.com/oauth2/aushhntkz13z5v9JX0i7',
    response_type: 'code',
    redirect_uri: window.location.origin + '/implicit/custom-callback',
    post_logout_redirect_uri: window.location.origin + '/',
    scopes: 'shiva openid',
    state: 'YYYY',
    nonce: 'YYYY',
    code_challenge: 'qrvgapdkr4CEacapa6oYCcU7BmDKBOApC2PHAAndgGY',
    code_verifier: 'id72dKsrgJQltBfrXkKu-0z-BHZCg5hmSsodywdn1VxeAGcjj9k4RxGjrAOGcxK4Lq8i3U7sssbx1D4bNIhEpcx_B5ohFc2-O1dcTbrvq_~2Ygr9aKku2dEPQHLku1g_',
    code_challenge_method: 'S256',
    grant_type: 'authorization_code',
  },
  // api manager
  getTokenBodyParams: JSON.stringify(['grant_type=urn:ietf:params:oauth:grant-type:jwt-bearer', 'assertion']),
  application : '',
  // keyId: 'a01f30b7-9080-4b37-913d-f0bc9587e14f',
  client_id: '',
  // search
  search: 'search',
  // client_secret: '707c516d-6353-42b3-b42f-863b14c1109f',
  tineaTokenUrl: '',
  // configs
  isEditableCreatable : {
    vehicle: false
  },
  // cube js
  urlDashboard: 'https://squad-sight-dashboard.digital.equans.com',
  cubeUrlApi: '/cubejs',

  // ENERGIES
  energyTypeIconsPath: {
    ELECTRICITY: '/assets/images/energies/electricity.svg',
    HYDROGEN: '/assets/images/energies/hydrogen.svg',
    GNL: '/assets/images/energies/gas.svg',
    GNC: '/assets/images/energies/gas.svg',
    GNCL: '/assets/images/energies/gas.svg',
    BIOGNC: '/assets/images/energies/gas.svg'
  },
  globalVehiculeEnergyPath: {
    ELECTRICITY: '/assets/images/energies/electricity.svg',
    HYDROGEN: '/assets/images/energies/hydrogen.svg',
    GAS: '/assets/images/energies/gas.svg',
    HYBRID: '/assets/images/energies/hybrid.svg',
  },
  iconMapCluster: "/assets/images/energies/cluster.svg",

  dashboard: dashboardEnvironment,

  regions: [
    {
      name: 'Alpes Sud',
      uid: 'bf0dcae1-705c-47ac-8bc0-4f1fe630be4f' ,
      contactName: null,
      contactNumber: null,
      contactEmail: null,
      idSiteList: [
        'b78b54f3-0f79-44ff-8c92-e87fea7408b9',
        'b8386bd4-986c-468c-b1e6-c25b2e4cc039',
        '61d18698-f3df-42dd-92a4-5c029e7b347c',
        '39162f8e-93e4-4391-b205-cbf700c45a2b'
      ]
    },
    {
      name: 'Grand Ouest',
      uid: '74e527b2-2810-4ad8-a165-571055fb1436' ,
      contactName: null,
      contactNumber: null,
      contactEmail: null,
      idSiteList: [
        '3b443626-94d3-420f-937b-8b993806d91c',
        '1def2c3a-2ade-4de6-92ce-1829e8b44d7e'
      ]
    },
    {
      name: 'Massif Central / Sud',
      uid: '964f8a44-5bf5-4c72-b26c-b543d2d204e5' ,
      contactName: 'Frédéric Concé',
      contactNumber: null,
      contactEmail: 'frederic.conce@hydrowatt.fr',
      idSiteList: [
        '354f9257-c01a-4481-bea4-c414254dc4da',
        '5c6d3461-e2c1-4cd1-b59b-154977f96e7c',
        'd7a60a43-df16-4be0-8692-308896805fb9',
        'a32f0e85-445d-48a3-9186-444d9f47a665',
        'c347cef9-95ff-4826-b699-70168a5775e0',
        '21703db3-89d3-43ca-8411-b433ca387861',
        'a5780fd3-ef4a-4ade-a0b8-b00c17e374d9',
        'eb71476d-8e7e-45eb-9785-1ba9d2e78205',
      ]
    },
    {
      name: 'Nord Est',
      uid: 'c33bac5a-598d-4a78-8d7b-6d4a19e197ed' ,
      contactName: null,
      contactNumber: null,
      contactEmail: null,
      idSiteList: [
        '6d99fae3-de69-47bd-80cd-c18e9f0db62c',
        'baf0d256-4ea8-4e03-9f77-fa0439b6fa42',
        'f490dc11-5fa5-43d0-ad4a-70c43dfec553',
        '6595e0d1-f013-498a-b14b-6d16379abc87',
        'fce926e6-72b1-43df-9d1c-4f91168d9bb9',
        'f148d0fb-5a5b-408d-a543-c0be195d0773'
      ]
    },
    {
      name: 'Pyrénées / Corse',
      uid: '651998f6-ee3f-4e0e-a005-4472a526c688' ,
      contactName: null,
      contactNumber: null,
      contactEmail: null,
      idSiteList: [
        '95ad8320-25e0-4f04-95c0-d342061576ee',
        '285688f3-b256-405c-86c9-74fb83c3e8b9',
        'ae1bdd24-3c2c-433f-acbb-798034d74eda',
        'dfdac55f-40f5-46b9-bc2c-5c84e4cd44e8',
        '941aa283-ada9-4877-98f2-786ae3b7d5cd',
        'df5737ab-baf1-4934-952e-3d2508d3d26a',
        'c0c2465f-7b16-47dd-b350-083da321860b',
        '9bcd73c7-3349-45a7-9377-c209cca6f95f',
        '1e718fe7-7c02-4767-b373-63f702e186cb'
      ]
    },
    {
      name: 'Seine',
      uid: 'f1e5edad-7fe7-4e7b-ae28-b42c9009a38d' ,
      contactName: null,
      contactNumber: null,
      contactEmail: null,
      idSiteList: [
        'd10e20bf-7a64-4751-9527-c4b2c3bb61a1',
        '738c032d-38d1-438b-9d1a-4b3cdb6852b1'
      ]
    },
    {
      name: 'Sud Est',
      uid: 'bdbf482c-ea35-44a0-b4c3-1dfa7e7d4040' ,
      contactName: null,
      contactNumber: null,
      contactEmail: null,
      idSiteList: [
        '9785d316-9932-4bc9-bc68-0688f3217f41',
        '89e91713-e80a-4427-9840-16fe88c797db',
        '0e13d438-95ce-4778-a3b7-58aa090a18a5',
        '4624423d-8a13-411f-9301-259ff1798538',
        'd421ab51-171f-4684-843f-1e3c5c5764c1',
        '31e850c4-c53a-4165-a4be-2f305d781cac',
        'a2821d6e-2cc2-48eb-a9b9-6addbda3e0b1',
        '4d9a1f9e-a888-47fd-926f-e345b6265769',
        'ba223f15-ae44-452a-b587-e6d03a87929d'
      ]
    },
  ],
  stationTags: [
    {
      uid: 'd7a60a43-df16-4be0-8692-308896805fb9', // herbeil @OK défini en BDD
      tags: [
        { name: '0:Herbeil.P_usine', uid:"efce96ad-b662-4003-89df-ed148b851186", type: 'power' },
        { name: '0:Herbeil.Niv_amont_MeC', uid: 'ed7a7812-7e98-4098-9197-da407c054aa3', type: 'water' }
      ]
    },
    {
      uid: 'c347cef9-95ff-4826-b699-70168a5775e0', // peyrusse @OK défini en BDD
      tags: [
        { name: '0:Peyrusse.P_usine', uid: 'e641c212-d865-4257-a454-0c06c4050909', type: 'power' },
        { name: '0:Peyrusse.Niv_Aval_Gr', uid: '5cd0c247-ab24-40c5-988a-c3baa1a1495f', type: 'water' }
      ]
    },
    {
      uid: '354f9257-c01a-4481-bea4-c414254dc4da', // Cantagrel @OK défini en BDD
      tags: [
        { name: '0:Cantagrel.M_PAC_g0', uid: '126d4384-a0ba-4b59-99a3-f26e2b0079aa', type: 'power' },
        { name: '0:Cantagrel.niv_rel_bar_mm', uid: '4ba69d57-b7ed-42b5-8ae0-8aa42e2d47f7', type: 'water' }
      ]
    },
    {
      uid: 'f148d0fb-5a5b-408d-a543-c0be195d0773', // Niederbourg @OK défini en BDD
      tags: [
        { name: '0:Niederbourg.P_Reseau', uid: '6e657961-9431-44a1-ae19-2b83dd742c91', type: 'power' },
        { name: '0:Niederbourg.Niveau_amont', uid: '0be78738-5143-491c-99c5-a57c78c89781', type: 'water' }
      ]
    },
    {
      uid: '9bcd73c7-3349-45a7-9377-c209cca6f95f', // Urs @OK défini en BDD
      tags: [
        { name: '0:Urs.P_usine', uid: 'ecfe22de-60fb-4473-91ea-4735bb41d923', type: 'power' },
        { name: '0:Urs.Niv_Amont', uid: 'a290c6fe-c7ef-456c-a5f5-4a26cb053294', type: 'water' }
      ]
    },
    {
      uid: 'a2821d6e-2cc2-48eb-a9b9-6addbda3e0b1', // Sirod @OK défini en BDD
      tags: [
        { name: '0:Sirod.mes_p_bt', uid: '280cac81-4fa0-4730-9063-0d7d2833489b', type: 'power' },
        { name: '0:Sirod.mes_niv_eau', uid: 'cd8df260-80c6-4d7b-a753-79ce62f3d3eb', type: 'water' }
      ]
    },
    {
      uid: 'ba223f15-ae44-452a-b587-e6d03a87929d', // Tours_en_savoie @OK défini en BDD
      tags: [
        { name: '0:Tours_en_savoie.P_usine', uid: '7e90363c-2039-469f-9b4b-7334f3257925', type: 'power' },
        { name: '0:Tours_en_savoie.Niv_amont_MeC', uid: 'f3c747dc-c91e-4784-8483-42f3160920d5', type: 'water' }
      ]
    },
    {
      uid: '95ad8320-25e0-4f04-95c0-d342061576ee', // Albies @OK défini en BDD
      tags: [
        { name: '0:Albies.P_usine', uid: '2e2340c8-aade-4c60-9dbd-43712ff2cbfe', type: 'power' },
        { name: '0:Albies.Niv_Amont', uid: 'c28c371f-67e0-41e0-a45f-1131891ce29a', type: 'water' }
      ]
    },
    {
      uid: '9785d316-9932-4bc9-bc68-0688f3217f41', // Chapogeres @OK défini en BDD
      tags: [
        { name: '0:Chapogeres.P_usine', uid: '72b84b6c-285e-41af-886e-cb472b04c51f', type: 'power' },
        { name: '0:Chapogeres.Niv_Amont', uid: 'bfd1f59e-6520-44da-b60c-b87ef5a2abf4', type: 'water' }
      ]
    },
    {
      uid: '6d99fae3-de69-47bd-80cd-c18e9f0db62c', // Bayard @OK défini en BDD
      tags: [
        { name: '0:Bayard.P_usine', uid: '795ed6ab-9870-41c6-a990-9d5c03ab0c79', type: 'power' },
        { name: '0:Bayard.Niveau_amont', uid: 'da05d19f-7d41-450e-a9a3-8cf20644d6fe', type: 'water' }
      ]
    },
    {
      uid: 'b78b54f3-0f79-44ff-8c92-e87fea7408b9', // La Meije 03 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Meije.P_usine', uid: '62f73679-cb16-4b8d-8d40-aef9ff771325', type: 'power' },
        { name: '0:Meije.Niv_Amont', uid: 'fdb04474-4a50-4fa1-b1c1-1594b418f781', type: 'water' }
      ]
    },
    {
      uid: '5c6d3461-e2c1-4cd1-b59b-154977f96e7c', // Fans 03 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Fans.Puis_kw', uid: '64aec083-e901-4e14-acde-58902ba05902', type: 'power' },
        { name: '0:Fans.Niv_reel_amont_bar', uid: '94e0aab0-7250-4da6-8210-880e31957a7a', type: 'water' }
      ]
    },
    {
      uid: 'fce926e6-72b1-43df-9d1c-4f91168d9bb9', // Lac du Der 03 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Lac_du_der.P_usine', uid: 'b09fcdf4-5cd5-4079-acd7-a856b09f16e0', type: 'power' },
        { name: '0:Lac_du_der.Niv_Amont', uid: 'a95ba708-a807-4394-8387-cb56d6aebd4f', type: 'water' }
      ]
    },
    {
      uid: '285688f3-b256-405c-86c9-74fb83c3e8b9', // Cazamozza 03 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Cazamozza.P_usine', uid: '00679ae4-6e56-43fe-9e49-3a4b1d47bbfd', type: 'power' },
        { name: '0:Cazamozza.Niv_Amont', uid: '49df62f0-9d89-4d4c-9179-17fb3d683acb', type: 'water' }
      ]
    },
    {
      uid: 'ae1bdd24-3c2c-433f-acbb-798034d74eda', // Castillon 03 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Castillon.SCANA_Puissance_active_totale', uid: '531adf2b-ad44-401d-9896-8efa471ef97b', type: 'power' },
        { name: '0:Castillon.Niv_Amont_Com', uid: '1d14f88a-7b42-4ab3-97c2-dca8071a9b2e', type: 'water' }
      ]
    },
    {
      uid: 'dfdac55f-40f5-46b9-bc2c-5c84e4cd44e8', // Giuncaggio 03 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Giuncaggio.P_Usine', uid: '81701018-aca2-4f77-a99e-6e76fbd3c272', type: 'power' },
        { name: '0:Giuncaggio.Niveau_amont', uid: '2fe6bca4-05f9-404b-9c84-8ed837f6454e', type: 'water' }
      ]
    },
    {
      uid: '941aa283-ada9-4877-98f2-786ae3b7d5cd', // Ledar 03 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Ledar.P_usine', uid: '4b9d523b-ca25-482a-ac02-a9def6ccee91', type: 'power' },
        { name: '0:Ledar.Niveau_Amont', uid: 'c8ca9ed6-6b29-4b21-855d-92aed562270c', type: 'water' }
      ]
    },
    {
      uid: '1e718fe7-7c02-4767-b373-63f702e186cb', // Villedubert 03 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Villedubert.Puissance_groupe', uid: 'e4e9d09e-5f95-4f3d-aee3-689f0402bc96', type: 'power' },
        { name: '0:Villedubert.Niveau_amont', uid: '24d9462a-19b6-4e8a-b3a9-af91accc6293', type: 'water' }
      ]
    },
    {
      uid: 'd10e20bf-7a64-4751-9527-c4b2c3bb61a1', // Portmort 03 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Portmort.Puiss_Total_Centrale', uid: '7811995f-d9f8-4bd0-9687-1e41b27b6a95', type: 'power' },
        { name: '0:Portmort.Niveau_Amont', uid: '7f31aab7-69da-4625-b8c0-6c2e856af7b7', type: 'water' }
      ]
    },
    {
      uid: '0e13d438-95ce-4778-a3b7-58aa090a18a5', // Cran_gevrier 03 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Cran_gevrier.P_G1', uid: '4825ffc9-aedf-45d8-bb8a-862236a0e3a5', type: 'power' },
        { name: '0:Cran_gevrier.Niv_Amont', uid: '85ff5974-1b5e-4881-b7f7-3572a3cedf1c', type: 'water' }
      ]
    },
    {
      uid: 'eb71476d-8e7e-45eb-9785-1ba9d2e78205', // Villemagne 03 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Villemagne.PUISSANCE', uid: '01d90da3-ae9b-4e7f-85fa-368b67291211', type: 'power' },
        { name: '0:Villemagne.Niv_eau', uid: 'd5025c34-c966-4980-b36e-c8bba9cb268f', type: 'water' }
      ]
    },
    {
      uid: '738c032d-38d1-438b-9d1a-4b3cdb6852b1', // Poses 04 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Poses.PuissTotal', uid: '2ebf89ca-13bf-4dab-9a62-288fc758cff4', type: 'power' },
        { name: '0:Poses.NiveauAmont', uid: '92e1800a-b706-43db-93d4-7a4b19f51e41', type: 'water' }
      ]
    },
    //{
    //  uid: '1def2c3a-2ade-4de6-92ce-1829e8b44d7e', // Rudet 04 janv 2022 PB CARACTERES TAGS
    //  tags: [
    //    { name: '0:Rudet.EA18_Puissance_KW', uid: 'dc86cac3-bad0-42ce-91c8-7f1911319d01', type: 'power' },
    //    { name: '0:Rudet.EA9_Niveau_d'eau_cm', uid: '', type: 'water' }
    //  ]
    //},
    {
      uid: '3b443626-94d3-420f-937b-8b993806d91c', // Mezos 04 janv 2022 @OK défini en BDD
      tags: [
        { name: '0:Mezos.P_Poste_20kV', uid: '5ccd62ce-5b9b-4bd4-ad1c-40b8b9df73a6', type: 'power' },
        { name: '0:Mezos.XBT_Irradiation_Pourcen', uid: 'd98d055a-a22a-49e1-971b-b59b97c5f531', type: 'irradiance' }
      ]
    },
    {
      uid: 'a32f0e85-445d-48a3-9186-444d9f47a665', // Lescure 02 mai 2022 @OK défini en BDD
      tags: [
        { name: '0:Lescure.HMI_PV_3', uid: 'f321f2d3-69d9-4d9d-99a4-08282fb50f10', type: 'power' },
        { name: '0:Lescure.Niv_Bar_mm', uid: '4b7410cf-2f2e-42a2-b259-684f87d8d55b', type: 'water' }
      ]
    }
  ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
